import { AlpineComponent } from '@alpinejs/csp';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Dialog = (): AlpineComponent => ({
  openDialog() {
    (this.$refs.dialog as HTMLDialogElement).showModal();
    disableBodyScroll(this.$refs.dialog);
  },

  closeDialog() {
    (this.$refs.dialog as HTMLDialogElement).close();
    enableBodyScroll(this.$refs.dialog);
  },
  init() {
    // Open dialog on button click
    const selector = `[data-js-dialog-toggle="${this.$refs.dialog.id}"]`;
    const toggle = document.querySelector(selector);

    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape' && (this.$refs.dialog as HTMLDialogElement).open) {
        this.closeDialog();
      }
    });

    if (toggle) {
      toggle.addEventListener('click', this.openDialog.bind(this));
    }
  }
});

export default Dialog;
